import React from "react";
import {
  FaCreditCard,
  FaCheckCircle,
  FaCalendarAlt,
  FaDownload,
  FaReceipt,
  
} from "react-icons/fa";

import "./PaymentHistory.css";

function PaymentHistory() {
  const payments = [
    {
      date: "20 May 2024",
      transactionId: "TXN240520000123",
      paymentType: "Membership Fee",
      amount: "₹ 1199.00",
      method: "UPI",
      status: "Paid",
    },
    {
      date: "20 May 2023",
      transactionId: "TXN230520000456",
      paymentType: "Membership Renewal",
      amount: "₹ 1199.00",
      method: "UPI",
      status: "Paid",
    },
  ];

  const totalPaid = payments.reduce((total, payment) => {
    const amount = Number(
      payment.amount.replace(/[₹,\s]/g, "")
    );

    return total + amount;
  }, 0);

  const latestPayment = payments[0];

  const downloadReceipt = (payment) => {
    const receiptContent = `
APNB SEVA SAMITHI
& VIDYA CHARITABLE TRUST

PAYMENT RECEIPT
----------------------------------------
Date: ${payment.date}
Transaction ID: ${payment.transactionId}
Payment Type: ${payment.paymentType}
Amount: ${payment.amount}
Payment Method: ${payment.method}
Status: ${payment.status}

Member Name: Ramesh Babu
Member ID: APNBM240520001

Thank you for your payment.
`;

    const blob = new Blob([receiptContent], {
      type: "text/plain",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download = `${payment.transactionId}-receipt.txt`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  };

  return (
    <main className="payment-history-page">

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <div className="payment-page-header">

        <div>
          <h1>Payment History</h1>

          <div className="payment-breadcrumb">
            <span>Home</span>

            <span className="payment-breadcrumb-arrow">
              ›
            </span>

            <span>Payment History</span>
          </div>
        </div>

      </div>


      {/* =====================================================
          SUMMARY CARDS
      ===================================================== */}

      <section className="payment-summary-grid">

        {/* TOTAL PAID */}

        <div className="payment-summary-card">

          <div className="payment-summary-icon blue">
            <FaCreditCard />
          </div>

          <div className="payment-summary-content">

            <span className="payment-summary-label">
              Total Paid
            </span>

            <strong>
              ₹{totalPaid.toFixed(2)}
            </strong>

          </div>

        </div>


        {/* SUCCESSFUL PAYMENTS */}

        <div className="payment-summary-card">

          <div className="payment-summary-icon green">
            <FaCheckCircle />
          </div>

          <div className="payment-summary-content">

            <span className="payment-summary-label">
              Successful Payments
            </span>

            <strong>
              {payments.length}
            </strong>

          </div>

        </div>


        {/* LATEST PAYMENT */}

        <div className="payment-summary-card">

          <div className="payment-summary-icon purple">
            <FaCalendarAlt />
          </div>

          <div className="payment-summary-content">

            <span className="payment-summary-label">
              Latest Payment
            </span>

            <strong>
              {latestPayment.date}
            </strong>

          </div>

        </div>

      </section>


      {/* =====================================================
          TRANSACTION HISTORY
      ===================================================== */}

      <section className="transaction-card">

        <div className="transaction-header">

          <div>
            <h2>
              Transaction History
            </h2>

            <p>
              View all your membership payments
            </p>
          </div>

        </div>


        {/* ===================================================
            TABLE
        =================================================== */}

        <div className="payment-table-wrapper">

          <table className="payment-table">

            <thead>

              <tr>

                <th>
                  Date
                </th>

                <th>
                  Transaction ID
                </th>

                <th>
                  Payment Type
                </th>

                <th>
                  Amount
                </th>

                <th>
                  Payment Method
                </th>

                <th>
                  Status
                </th>

                <th>
                  Receipt
                </th>

              </tr>

            </thead>


            <tbody>

              {payments.map((payment) => (

                <tr key={payment.transactionId}>

                  <td>
                    {payment.date}
                  </td>

                  <td className="transaction-id">
                    {payment.transactionId}
                  </td>

                  <td>
                    {payment.paymentType}
                  </td>

                  <td className="payment-amount">
                    {payment.amount}
                  </td>

                  <td>
                    {payment.method}
                  </td>

                  <td>

                    <span className="payment-status">

                      <FaCheckCircle />

                      Paid

                    </span>

                  </td>

                  <td>

                    <button
                      type="button"
                      className="receipt-button"
                      onClick={() =>
                        downloadReceipt(payment)
                      }
                    >

                      <FaDownload />

                      <span>
                        Download
                      </span>

                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </section>


      {/* =====================================================
          INFORMATION MESSAGE
      ===================================================== */}

      <div className="payment-information">

        <FaReceipt />

        <span>
          All successful payments have a downloadable
          receipt. Keep your receipts for future reference.
        </span>

      </div>


    </main>
  );
}

export default PaymentHistory;